import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z" />, 'FastForward');
